import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { trackPhoneConversion } from "../utils/tracking";


const PHONE = "+359876995651";
const PHONE_DISPLAY = "+359 876 995 651";
const EMAIL = "rangelovkomrs@gmail.com";

const services = [
  { to: "/hamalski-uslugi", label: "Хамалски услуги" },
  { to: "/transportni-uslugi", label: "Транспортни услуги" },
  { to: "/ofis-hamali", label: "Преместване на офиси" },
  { to: "/pochistvane", label: "Почистване на мазета и тавани" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      style={{
        backgroundColor: "#050505",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        paddingBottom: "72px",
      }}
    >
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "3rem 1.25rem 2rem" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "2.5rem" }}>

          {/* Brand */}
          <div>
            <Link to="/">
              <img src="/logo.svg" alt="Хамали София" style={{ height: "52px", marginBottom: "1rem" }} />
            </Link>
            <p style={{ color: "#A1A1AA", fontSize: "0.875rem", lineHeight: "1.7", marginBottom: "1.25rem" }}>
              Вашият надежден партньор за хамалски, транспортни услуги и почистване в София и София-област.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 style={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 800,
              fontSize: "0.8rem",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: "#2dcf0c",
              marginBottom: "1.25rem",
            }}>
              Услуги
            </h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "0.625rem" }}>
              {services.map((s) => (
                <li key={s.to}>
                  <Link
                    to={s.to}
                    data-testid={`footer-link-${s.to.slice(1)}`}
                    style={{
                      color: "#A1A1AA",
                      textDecoration: "none",
                      fontSize: "0.875rem",
                      transition: "color 0.2s ease",
                    }}
                    onMouseEnter={(e) => { e.target.style.color = "#2dcf0c"; }}
                    onMouseLeave={(e) => { e.target.style.color = "#A1A1AA"; }}
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 style={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 800,
              fontSize: "0.8rem",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: "#2dcf0c",
              marginBottom: "1.25rem",
            }}>
              Контакти
            </h3>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.875rem" }}>
              <a
                href={`tel:${PHONE}`}
                data-testid="footer-phone"
                style={{ display: "flex", alignItems: "center", gap: "0.625rem", color: "#FFFFFF", textDecoration: "none", fontSize: "0.95rem", fontWeight: 700 }}
                onClick={trackPhoneConversion}
              >
                <Phone size={15} color="#2dcf0c" />
                {PHONE_DISPLAY}
              </a>
              <a
                href={`mailto:${EMAIL}`}
                data-testid="footer-email"
                style={{ display: "flex", alignItems: "center", gap: "0.625rem", color: "#A1A1AA", textDecoration: "none", fontSize: "0.875rem" }}
              >
                <Mail size={15} color="#2dcf0c" />
                {EMAIL}
              </a>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "0.625rem", color: "#A1A1AA", fontSize: "0.875rem" }}>
                <MapPin size={15} color="#2dcf0c" style={{ marginTop: "2px", flexShrink: 0 }} />
                <span>София и София-област</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          marginTop: "2.5rem",
          paddingTop: "1.5rem",
          borderTop: "1px solid rgba(255,255,255,0.06)",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "0.5rem",
        }}>
          <p style={{ color: "#71717A", fontSize: "0.8rem" }}>
            © {new Date().getFullYear()} Хамали София. Всички права запазени.
          </p>
          <p style={{ color: "#71717A", fontSize: "0.8rem" }}>
            Работно време: 7:00 – 22:00, всеки ден
          </p>
          <p style={{ color: "#71717A", fontSize: "0.8rem" }}>
            Web Design &amp; Development:{" "}
            <a
              href="https://nedkov-digital.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-nedkov-link"
              style={{
                color: "#A1A1AA",
                textDecoration: "none",
                transition: "color 0.2s ease",
              }}
              onMouseEnter={(e) => { e.target.style.color = "#60a5fa"; }}
              onMouseLeave={(e) => { e.target.style.color = "#A1A1AA"; }}
            >
              NedkovDigital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
